export const CONTROL = Object.freeze({
  TEXT: 'text',
  NUMBER: 'number',
  TEXTAREA: 'textarea',
  SWITCH: 'switch',
  CHECKBOX: 'checkbox',
  CHECKBOX_GROUP: 'checkbox_group',
  RADIO: 'radio',
  RADIO_GROUP: 'radio_group',
  GROUP: 'group',
  ICON: 'icon',
  DATE_RANGE: 'date_range',
  PERMALINK: 'permalink',
  ADMIN_EMAILS: 'admin_emails',
  TEXTFIELD_WITH_PERMALINK: 'textfield_with_permalink',
})

export const TOOL_TABS = Object.freeze({
  FIRST: 'toolBuilder.tabs.first',
  SECOND: 'toolBuilder.tabs.second',
})
